import React from 'react'
import { displayDollar, displayTicketSize } from '../../lib/utils/helpers'
import { OpportunityDetailHighlightsProps } from '../../lib/types'
import {
  getCmsTargetReturn,
  getFeeHighlights,
  OPPORTUNITY_SECTION_IDS,
} from './opportunity-detail.utils'

const OpportunityDetailHighlights = ({
  project,
  opportunityDetails,
}: OpportunityDetailHighlightsProps) => {
  const cmsTargetReturn = getCmsTargetReturn(opportunityDetails?.fees)
  const showRaiseGoal = opportunityDetails?.showRaiseGoal === true
  const hasRaiseGoalValue = Boolean(project?.raiseGoal && project.raiseGoal !== '0')
  const detailHighlights = [
    ...(cmsTargetReturn
      ? [
          {
            label: 'Target Return',
            value: cmsTargetReturn,
          },
        ]
      : []),
    {
      label: 'Minimum Amount',
      value: displayTicketSize(project?.ticketSize, project?.currencyCode) || '$0',
    },
    ...(showRaiseGoal
      ? [
          {
            label: hasRaiseGoalValue ? 'Raise Goal' : 'Committed Value',
            value: hasRaiseGoalValue
              ? displayDollar(project?.raiseGoal, project?.currencyCode) || '$0'
              : displayDollar(project?.committedAmount, project?.currencyCode) || '$0',
          },
        ]
      : []),
    ...getFeeHighlights(opportunityDetails?.fees),
  ]
  const highlightCount = detailHighlights.length

  if (!highlightCount) {
    return null
  }

  return (
    <section
      id={OPPORTUNITY_SECTION_IDS.highlights}
      className='opportunity-overview-panel opportunity-stats-card'
    >
      <div
        className={`opportunity-hero-stat-grid opportunity-hero-stat-grid--count-${highlightCount}`}
      >
        {detailHighlights.map((highlight, index) => (
          <div className='opportunity-hero-stat' key={`${highlight.label}-${index}`}>
            <span className='opportunity-hero-stat-label'>{highlight.label}</span>
            <span className='opportunity-hero-stat-value'>{highlight.value}</span>
          </div>
        ))}
      </div>
    </section>
  )
}

export default OpportunityDetailHighlights
